import * as angular from 'angular';
import {IPromise, IQService} from 'angular';
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {TravelTimeRuleRequestsService} from "./travel-time-rule-requests.service";
import {VehicleType} from "../../commons/types/vehicle.type";
import {TravelTimeRuleAlerts} from "./travel-time-rule-alerts.service";
import {TravelTimeRuleModel} from "../models/travel-time-rule.model";

export class TravelTimeRuleService {

  /* @ngInject */
  constructor(private travelTimeRuleRequestsService: TravelTimeRuleRequestsService,
              private travelTimeRuleAlerts: TravelTimeRuleAlerts,
              private $q: IQService,
              private bringozLoaderService: BringozLoaderService,) {
  }

  getRules(vehicleType: VehicleType) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.travelTimeRuleRequestsService.getRules(vehicleType)
      .then((rules: TravelTimeRuleModel[]) => {
        deferred.resolve(rules);
      })
      .catch((error) => {
        this.travelTimeRuleAlerts.getRulesError();
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  createRule(travelTimeRule: TravelTimeRuleModel) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.travelTimeRuleRequestsService.createRule(travelTimeRule)
      .then((rule: TravelTimeRuleModel) => {
        this.travelTimeRuleAlerts.createRuleSuccess();
        deferred.resolve(rule);
      })
      .catch((error) => {
        this.travelTimeRuleAlerts.createRuleError();
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  updateRule(id: string, travelTimeRule: TravelTimeRuleModel) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.travelTimeRuleRequestsService.updateRule(id, travelTimeRule)
      .then((rule: TravelTimeRuleModel) => {
        this.travelTimeRuleAlerts.updateRuleSuccess();
        deferred.resolve(rule);
      })
      .catch((error) => {
        this.travelTimeRuleAlerts.updateRuleError();
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }

  deleteRule(id: string) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.travelTimeRuleRequestsService.deleteRule(id)
      .then((rule: TravelTimeRuleModel) => {
        this.travelTimeRuleAlerts.deleteRuleSuccess();
        deferred.resolve(rule);
      })
      .catch((error) => {
        this.travelTimeRuleAlerts.deleteRuleError();
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise
  }


}

angular
  .module('bringoz.admin.site-preferences')
  .service('travelTimeRuleService', TravelTimeRuleService);
